export default __webpack_public_path__ + "static/media/background5.8da8e7d7.png";